<div class="container-fluid">
    <!-- Espacio extra para el sticky footer -->
    <div style="margin-bottom: 100px;"></div>
    
    <!-- Stepper Header -->
    <div class="row" style="margin-top: -20px;">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <!-- Spinner para cargar o editar ebook -->
                    <div *ngIf="loadingEbook" class="spinner-container">
                        <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                        </div>
                        <p class="text-primary">Cargando ebook...</p>
                    </div>
                    <!-- Stepper Navigation -->
                    <mat-stepper #stepper [selectedIndex]="step" [linear]="true" orientation="horizontal">
                    
                        <!-- Step 1: Contenido -->
                        <mat-step [completed]="step > 0" [stepControl]="firstFormGroup">
                            <ng-template matStepLabel>Contenido</ng-template>
                            <div class="row">
                                <div class="col-12 py-4 bg-white" [ngClass]="{'col-md-3': step === 0}">
                                    <form>
                                        <!-- Step 0: Contenido (Todo el formulario de new-product) -->
                                        <div class="form-group" *ngIf="step === 0">
                                            <mat-form-field class="w-100 mb-3" appearance="outline">
                                                <mat-label>Nombre/Idea</mat-label>
                                                <input matInput type="text" required class="w-100" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="ebook.Title" (keyup)="generateSlug($event); checkButtonState()" aria-describedby="addon-wrapping">
                                            </mat-form-field>
                                            
                                            <mat-form-field appearance="outline" class="w-100 mb-3">
                                                <mat-label>Categoría</mat-label>
                                                <select matNativeControl [(ngModel)]="ebook.Category" [ngModelOptions]="{standalone: true}"
                                                    (change)="selectCategory($event)">
                                                    <option value="">Selecciona</option>
                                                    <option *ngFor="let category of categories" [value]="category.id">{{category.ValueAlpha}}</option>
                                                </select>
                                            </mat-form-field>
                                            
                                            <mat-form-field appearance="outline" class="w-100 mb-3">
                                                <mat-label>Nivel</mat-label>
                                                <select matNativeControl [(ngModel)]="ebook.Level" [ngModelOptions]="{standalone: true}"
                                                    (change)="selectLevel($event)">
                                                    <option value="">Selecciona</option>
                                                    <option *ngFor="let level of levels" [value]="level.id">{{level.ValueAlpha}}</option>
                                                </select>
                                            </mat-form-field>
                                            
                                            <mat-form-field class="w-100 mb-3" appearance="outline">
                                                <mat-label>Precio</mat-label>
                                                <input matInput type="number" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="ebook.UnitPrice" (change)="checkButtonState()" min="0" aria-describedby="addon-wrapping">
                                            </mat-form-field>
                                            
                                            <mat-form-field class="w-100 mb-3" appearance="outline">
                                                <mat-label>Descripción</mat-label>
                                                <textarea matInput [(ngModel)]="ebook.Description" [ngModelOptions]="{standalone: true}"
                                                    (keyup)="checkButtonState()" maxlength="400" aria-describedby="addon-wrapping"></textarea>
                                                <mat-hint align="end">{{ ebook.Description?.length || 0 }}/400</mat-hint>
                                            </mat-form-field>
                                            
                                            <mat-form-field required class="w-100 mb-3" appearance="outline">
                                                <mat-label>¿Qué aprenderás?</mat-label>
                                                <mat-chip-grid #chipGrid>
                                                    @for (learn of learning; track learn) {
                                                        <mat-chip-row (removed)="remove(learn)" [editable]="true"
                                                            [aria-description]="'press enter to edit ' + learn.name">
                                                            {{learn.name}}
                                                            <button matChipRemove [attr.aria-label]="'remove ' + learn.name">
                                                            <mat-icon>cancel</mat-icon>
                                                            </button>
                                                        </mat-chip-row>
                                                    }
                                                    <input placeholder="¿Qué aprenderás?" [matChipInputFor]="chipGrid"
                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                                                    (matChipInputTokenEnd)="add($event)" />
                                                </mat-chip-grid>
                                            </mat-form-field>
                                
                                            <mat-form-field required class="w-100 mb-3" appearance="outline">
                                                <mat-label>¿A quién va dirigido?</mat-label>
                                                <mat-chip-grid #chipGrid2>
                                                    @for (learn of target; track learn) {
                                                        <mat-chip-row (removed)="removeTarget(learn)" [editable]="true"
                                                            [aria-description]="'press enter to edit ' + learn.name">
                                                            {{learn.name}}
                                                            <button matChipRemove [attr.aria-label]="'remove ' + learn.name">
                                                            <mat-icon>cancel</mat-icon>
                                                            </button>
                                                        </mat-chip-row>
                                                    }
                                                    <input placeholder="¿A quién va dirigido?" [matChipInputFor]="chipGrid2"
                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                                                    (matChipInputTokenEnd)="addTarget($event)" />
                                                </mat-chip-grid>
                                            </mat-form-field>
                                
                                            <div class="col-12">
                                                <label>Imagen profesional</label>
                                                
                                                <!-- Si hay una imagen guardada y no se ha subido una nueva, mostrar la imagen existente -->
                                                <div *ngIf="ebook.ImgFileUrl && !newImageSelected" class="existing-image-preview">
                                                    <img [src]="ebook.ImgFileUrl" alt="Imagen guardada" style="max-width: 100%; height: auto;"/>
                                                    <button mat-button class="btn btn-sm btn-primary" style="margin-top: 10px;" (click)="removeExistingImage()">Cambiar imagen</button>
                                                </div>
                                                
                                                <!-- Mostrar el dropzone solo si no hay imagen guardada o si se seleccionó una nueva -->
                                                <ngx-dropzone *ngIf="!ebook.ImgFileUrl || newImageSelected" (change)="onSelectImages($event)" [multiple]="false">
                                                    <ngx-dropzone-label class="label-file">Arrastra una imagen aquí o haz clic para seleccionar una imagen.</ngx-dropzone-label>
                                                    
                                                    <!-- Previsualización de la nueva imagen seleccionada -->
                                                    <ngx-dropzone-image-preview *ngFor="let f of imagesX" [file]="f" [removable]="true" (removed)="removeImage(f)">
                                                    <ngx-dropzone-label>{{ f.name.substr(1, 10) }}... / ({{ f.type }})</ngx-dropzone-label>
                                                    </ngx-dropzone-image-preview>
                                                </ngx-dropzone>
                                                
                                                <!-- Mostrar el link de la imagen cargada si ya se subió -->
                                                <section *ngIf="responseImgFile" style="margin-top: 10px;">
                                                    <a [href]="responseImgFile" target="_blank" style="color:#33bd38">Imagen cargada <i class="fa fa-check" aria-hidden="true"></i></a>
                                                </section>
                                            </div>

                                            <div class="col-12 mt-4">
                                                <label>Archivo del Ebook <span class="text-danger">*</span></label>
                                                <small class="form-text text-muted mb-2">Formatos permitidos: .epub, .pdf, .mobi, .azw</small>
                                                
                                                <!-- Si hay un archivo guardado y no se ha subido uno nuevo, mostrar el archivo existente -->
                                                <div *ngIf="responseEbookFile && !newEbookFileSelected" class="existing-file-preview mb-3">
                                                    <div class="alert alert-info">
                                                      <div class="d-flex align-items-start">
                                                        <i class="fas fa-file-alt fa-2x me-3 mt-1"></i>
                                                        <div class="flex-grow-1">
                                                          <strong>Archivo actual:</strong>
                                                          <br>
                                                          <small class="text-muted">{{ EbookfileName || 'Archivo del ebook' }}</small>
                                                          <br>
                                                          <small class="text-muted" *ngIf="isEditMode && existingProductInfoId">
                                                            ID: {{ existingProductInfoId }} | Tipo: {{ getFileExtension(EbookfileName) }}
                                                          </small>
                                                        </div>
                                                      </div>
                                                  
                                                      <!-- Botones al final, en fila -->
                                                      <div class="mt-3 d-flex justify-content-end gap-2">
                                                        <a [href]="responseEbookFile" target="_blank" class="btn btn-outline-primary w-100">
                                                          <i class="fas fa-download"></i> Descargar
                                                        </a>
                                                        <button type="button" class="btn btn-outline-secondary w-100" (click)="removeExistingEbookFile()">
                                                          <i class="fas fa-sync-alt"></i> Cambiar
                                                        </button>
                                                      </div>
                                                    </div>
                                                </div>
                                                
                                                <!-- Mostrar el dropzone solo si no hay archivo guardado o si se seleccionó uno nuevo -->
                                                <ngx-dropzone 
                                                  *ngIf="!ebook.EbookFileUrl || newEbookFileSelected" 
                                                  (change)="onSelectEbookFiles($event)" 
                                                  [multiple]="false"
                                                  [accept]="'.epub,.pdf,.mobi,.azw'"
                                                  class="custom-dropzone-file">
                                                  <ngx-dropzone-label class="label-file">
                                                    <p>Arrastra el archivo del ebook aquí o haz clic para seleccionar</p>
                                                    <!-- <small class="text-muted">Solo se permite un archivo (.epub, .pdf, .mobi, .azw)</small> -->
                                                  </ngx-dropzone-label>
                                                  
                                                  <!-- Previsualización del nuevo archivo seleccionado -->
                                                  <ngx-dropzone-preview 
                                                    *ngFor="let f of ebookFiles" 
                                                    [file]="f" 
                                                    [removable]="true" 
                                                    (removed)="removeEbookFile(f)">
                                                    <ngx-dropzone-label>
                                                      <i class="fas fa-file-alt fa-2x mb-2"></i>
                                                      <br>
                                                      <strong>{{ f.name }}</strong>
                                                      <br>
                                                      <small class="text-muted">{{ (f.size / 1024 / 1024).toFixed(2) }} MB</small>
                                                    </ngx-dropzone-label>
                                                  </ngx-dropzone-preview>
                                                </ngx-dropzone>
                                                
                                                <!-- Mostrar el link del archivo cargado si ya se subió -->
                                                <section *ngIf="responseEbookFile" class="mt-2">
                                                  <div class="alert alert-success d-flex align-items-center">
                                                    <i class="fas fa-check-circle me-2"></i>
                                                    <span>Archivo del ebook cargado correctamente</span>
                                                    <a [href]="responseEbookFile" target="_blank" class="ms-auto text-success">
                                                      <i class="fas fa-external-link-alt"></i> Ver archivo
                                                    </a>
                                                  </div>
                                                </section>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            
                                <!-- Preview del ebook (solo en step 0) -->
                                <div class="col-12 col-md-9" *ngIf="step === 0">
                                    <div class="bg-white">
                                    <div class="browser-window w-100">
                                        <div class="browser-header">
                                        <div class="buttons">
                                            <span class="button close"></span>
                                            <span class="button minimize"></span>
                                            <span class="button maximize"></span>
                                        </div>
                                        <div class="address-bar">
                                            <input type="text" disabled [value]="ebook.Slug" readonly>
                                        </div>
                                        </div>
                                        <div class="browser-content">
                                        <div class="row">
                                            <div class="col-12 col-md-7">
                                            <div class="course-detalis-wrapper mb-30">
                                                <div class="course-title-breadcrumb text-dark">
                                                <nav>
                                                    <ol class="breadcrumb">
                                                    <li class="breadcrumb-item-front"><a href="/">Inicio</a></li>
                                                    <li class="breadcrumb-item-front"><span>{{ ebook.Title }}</span></li>
                                                    </ol>
                                                </nav>
                                                </div>
                                                <div class="course-heading mb-20">
                                                <h2>{{ebook.Title}}</h2>
                                                </div>
                                                <div class="course-detelis-meta" style="text-align: center;">
                                                <div class="course-meta-wrapper border-line-meta">
                                                    <div class="course-meta-img">
                                                    <a>
                                                        <img style="object-fit: cover;" 
                                                             *ngIf="currentUser?.imgProfile"
                                                             [src]="currentUser?.imgProfile" 
                                                             (error)="handleProfileImageError($event)"
                                                             alt="Foto de perfil">
                                                        <img style="object-fit: cover;" 
                                                             *ngIf="!currentUser?.imgProfile"
                                                             src="assets/images/user.png" 
                                                             alt="Foto de perfil por defecto">
                                                    </a>
                                                    </div>
                                                    <div class="course-meta-text">
                                                    <span>Creado Por</span>
                                                    <h6><b>{{ currentUser?.displayName }}</b></h6>
                                                    </div>
                                                </div>
                                                <div class="course-update border-line-meta">
                                                    <p>Categoría</p>
                                                    <b>{{ categorySelected?.ValueAlpha }}</b>
                                                </div>
                                                <div class="course-category">
                                                    <p>Nivel</p>
                                                    <b>{{ levelSelected?.ValueAlpha }}</b>
                                                </div>
                                                </div>
                                                <div class="course-description pt-4 pb-3">
                                                <div class="course-Description">
                                                    <h4>Descripción</h4>
                                                </div>
                                                <p [innerHTML]="ebook.Description"></p>
                                                </div>
                                                <div class="course-learn-wrapper">
                                                <div class="course-learn">
                                                    <div class="course-leranm-tittle">
                                                    <h4 class="mb-8"><b>¿Qué Aprenderás?</b></h4>
                                                    </div>
                                                    <div class="row">
                                                    <div class="col-xl-12">
                                                        <div>
                                                        <ul>
                                                            @for (learn of learning; track learn) {
                                                            <li>
                                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                                {{ learn.name }}
                                                            </li>
                                                            }
                                                        </ul>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                                <div class="course-requirements pt-5">
                                                <h4 class="title-4"><b>¿A quién va dirigido?</b></h4>
                                                <div class="course-requirements-text">
                                                    <ul>
                                                    @for (learn of target; track learn) {
                                                        <li>
                                                        {{ learn.name }}
                                                        </li>
                                                    }
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="col-12 col-md-5">
                                            <div class="course-video-widget">
                                                <div class="course-widget-wrapper mb-30">
                                                <div class="course-video-thumb w-img">
                                                    <!-- Placeholder si no hay imagen -->
                                                    <img alt="Portada del ebook" 
                                                         *ngIf="!getImagePreview()"
                                                         src="assets/images/placeholder.png">
                                                    <!-- Imagen seleccionada o cargada -->
                                                    <img alt="Portada del ebook" 
                                                         *ngIf="getImagePreview()" 
                                                         [src]="getImagePreview()"
                                                         (error)="handleImageError($event)">
                                                </div>
                                                <div class="course-video-price">
                                                    <div class="event-price-info">
                                                    <div class="event-ticket-cost"><span>Precio:</span></div>
                                                    <div class="event-price"><span>${{ ebook.UnitPrice | number: '1.2-2' }} MXN</span>
                                                        <div class="old-price"><!----></div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="course-video-body">
                                                    <ul>
                                                    <li>
                                                        <div class="course-vide-icon"><i class="flaticon-filter"></i><span>Nivel</span></div>
                                                        <div class="video-corse-info"><span>{{ levelSelected?.ValueAlpha }}</span></div>
                                                    </li>
                                                    <li>
                                                        <div class="course-vide-icon"><i class="flaticon-menu-2"></i><span>Categoría</span></div>
                                                        <div class="video-corse-info"><span>{{ categorySelected?.ValueAlpha }}</span></div>
                                                    </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                    
                        <!-- Step 2: Ficha -->
                        <mat-step [completed]="false" [stepControl]="secondFormGroup" [editable]="false">
                            <ng-template matStepLabel>Ficha</ng-template>
                            <!-- Step 1: Ficha - Preview del ebook -->
                            <div *ngIf="step === 1">
                                <!-- Preview del ebook (igual que en step 0) -->
                                <div class="bg-white">
                                    <div class="browser-window w-100">
                                        <div class="browser-header">
                                            <div class="buttons">
                                                <span class="button close"></span>
                                                <span class="button minimize"></span>
                                                <span class="button maximize"></span>
                                            </div>
                                            <div class="address-bar">
                                                <input type="text" disabled [value]="ebook.Slug" readonly>
                                            </div>
                                        </div>
                                        <div class="browser-content">
                                            <div class="row">
                                                <div class="col-12 col-md-7">
                                                    <div class="course-detalis-wrapper mb-30">
                                                        <div class="course-title-breadcrumb text-dark">
                                                            <nav>
                                                                <ol class="breadcrumb">
                                                                    <li class="breadcrumb-item-front"><a href="/">Inicio</a></li>
                                                                    <li class="breadcrumb-item-front"><span>{{ ebook.Title }}</span></li>
                                                                </ol>
                                                            </nav>
                                                        </div>
                                                        <div class="course-heading mb-20">
                                                            <h2>{{ebook.Title}}</h2>
                                                        </div>
                                                        <div class="course-detelis-meta" style="text-align: center;">
                                                            <div class="course-meta-wrapper border-line-meta">
                                                                <div class="course-meta-img">
                                                                    <a>
                                                                        <img style="object-fit: cover;" 
                                                                             *ngIf="currentUser?.imgProfile"
                                                                             [src]="currentUser?.imgProfile" 
                                                                             (error)="handleProfileImageError($event)"
                                                                             alt="Foto de perfil">
                                                                        <img style="object-fit: cover;" 
                                                                             *ngIf="!currentUser?.imgProfile"
                                                                             src="assets/images/user.png" 
                                                                             alt="Foto de perfil por defecto">
                                                                    </a>
                                                                </div>
                                                                <div class="course-meta-text">
                                                                    <span>Creado Por</span>
                                                                    <h6><b>{{ currentUser?.displayName }}</b></h6>
                                                                </div>
                                                            </div>
                                                            <div class="course-update border-line-meta">
                                                                <p>Categoría</p>
                                                                <b>{{ categorySelected?.ValueAlpha }}</b>
                                                            </div>
                                                            <div class="course-category">
                                                                <p>Nivel</p>
                                                                <b>{{ levelSelected?.ValueAlpha }}</b>
                                                            </div>
                                                        </div>
                                                        <div class="course-description pt-4 pb-3">
                                                            <div class="course-Description">
                                                                <h4>Descripción</h4>
                                                            </div>
                                                            <p [innerHTML]="ebook.Description"></p>
                                                        </div>
                                                        <div class="course-learn-wrapper">
                                                            <div class="course-learn">
                                                                <div class="course-leranm-tittle">
                                                                    <h4 class="mb-8"><b>¿Qué Aprenderás?</b></h4>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-xl-12">
                                                                        <div>
                                                                            <ul>
                                                                                @for (learn of learning; track learn) {
                                                                                <li>
                                                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                                                    {{ learn.name }}
                                                                                </li>
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="course-requirements pt-5">
                                                            <h4 class="title-4"><b>¿A quién va dirigido?</b></h4>
                                                            <div class="course-requirements-text">
                                                                <ul>
                                                                    @for (learn of target; track learn) {
                                                                        <li>
                                                                            {{ learn.name }}
                                                                        </li>
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-5">
                                                    <div class="course-video-widget">
                                                        <div class="course-widget-wrapper mb-30">
                                                            <div class="course-video-thumb w-img">
                                                                <!-- Placeholder si no hay imagen -->
                                                                <img alt="Portada del ebook" 
                                                                     *ngIf="!getImagePreview()"
                                                                     src="assets/images/placeholder.png">
                                                                <!-- Imagen seleccionada o cargada -->
                                                                <img alt="Portada del ebook" 
                                                                     *ngIf="getImagePreview()" 
                                                                     [src]="getImagePreview()"
                                                                     (error)="handleImageError($event)">
                                                            </div>
                                                            <div class="course-video-price">
                                                                <div class="event-price-info">
                                                                    <div class="event-ticket-cost"><span>Precio:</span></div>
                                                                    <div class="event-price"><span>${{ ebook.UnitPrice | number: '1.2-2' }} MXN</span>
                                                                        <div class="old-price"><!----></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="course-video-body">
                                                                <ul>
                                                                    <li>
                                                                        <div class="course-vide-icon"><i class="flaticon-filter"></i><span>Nivel</span></div>
                                                                        <div class="video-corse-info"><span>{{ levelSelected?.ValueAlpha }}</span></div>
                                                                    </li>
                                                                    <li>
                                                                        <div class="course-vide-icon"><i class="flaticon-menu-2"></i><span>Categoría</span></div>
                                                                        <div class="video-corse-info"><span>{{ categorySelected?.ValueAlpha }}</span></div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- COMENTADO: Preview anterior con iframe externo -->
                                <!-- <iframe [src]="WEBURL+'/curso/'+slug | safeUrl" class="w-100"
                                style="height: 600px;" frameborder="0"></iframe> -->
                            </div>
                        </mat-step>
                    </mat-stepper>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Sticky footer para botones de acción -->
    <div class="sticky-footer-botones" id="stickyFooter">
        <div class="container d-flex justify-content-between align-items-center">
            <!-- Botón Cancelar (solo si no está en modo edición) -->
            <button
                *ngIf="!isEditMode"
                mat-button
                class="btn btn-danger"
                (click)="cancelarEbook()">
                Cancelar Ebook
            </button>
            <div *ngIf="isEditMode"></div>
            
            <div>
                <!-- Botones para el paso 0: CONTENIDO -->
                <ng-container *ngIf="step === 0">
                    <button
                        class="btn btn-primary"
                        [disabled]="isButtonDisabled"
                        (click)="nextStep()">
                        <span *ngIf="!isButtonDisabled">Continuar</span>
                        <span *ngIf="isButtonDisabled">Complete todos los campos</span>
                    </button>
                </ng-container>
                
                <!-- Botones para el paso 1: FICHA -->
                <ng-container *ngIf="step === 1">
                    <button
                        class="btn btn-secondary me-2"
                        (click)="previousStep()">
                        <i class="fas fa-arrow-left"></i> Anterior
                    </button>
                    <button
                        class="btn btn-outline-primary me-2"
                        (click)="actualizarBorrador()">
                        <i class="fas fa-save"></i> {{ isEditMode ? 'Actualizar borrador' : 'Crear borrador' }}
                    </button>
                    <button
                        class="btn btn-primary"
                        (click)="saveAndSendToReview()">
                        <i class="fas fa-globe"></i> Guardar y publicar
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>